// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Notifiche in-app + browser push (Notification API) ======
// Schema dati: tabella public.notifications (vedi seed/notifications-schema.sql)
// Realtime: subscribe ai nuovi insert per il proprio user_id.
// Browser: Notification API per popup nativi quando l'utente e' loggato e ha dato permesso.
// Login: al login mostriamo una notifica riassuntiva se ci sono unread.

let _notifications = []; // cache locale ultime 50 notifiche
let _notifUnread = 0;
let _notifRealtimeChannel = null;
let _notifPollTimer = null;

const notifApi = {
  async list(limit = 50) {
    const { data, error } = await sb
      .from('notifications')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data || [];
  },

  async unreadCount() {
    const { data, error } = await sb.rpc('unread_count');
    if (error) throw error;
    return Number(data) || 0;
  },

  async markRead(id) {
    const { error } = await sb.rpc('mark_notification_read', { p_id: id });
    if (error) throw error;
  },

  async markAllRead() {
    const { data, error } = await sb.rpc('mark_all_notifications_read');
    if (error) throw error;
    return Number(data) || 0;
  },

  async remove(id) {
    const { error } = await sb.from('notifications').delete().eq('id', id);
    if (error) throw error;
  },

  // Inviare notifiche (admin-side) — niente email, va dritto in-app
  async notifyAdmins(type, title, body, payload, priority) {
    const { error } = await sb.rpc('notify_admins', {
      p_type: type,
      p_title: title,
      p_body: body || '',
      p_payload: payload || {},
      p_priority: priority || 'info',
      p_source_event: ''
    });
    if (error) console.warn('notify_admins error', error);
  },

  async notifyUser(userId, type, title, body, payload, priority) {
    if (!userId) return;
    const { error } = await sb.rpc('notify_user', {
      p_user_id: userId,
      p_type: type,
      p_title: title,
      p_body: body || '',
      p_payload: payload || {},
      p_priority: priority || 'info',
      p_source_event: ''
    });
    if (error) console.warn('notify_user error', error);
  }
};

// ===== Browser Notification API =====
async function ensureBrowserNotifPermission() {
  if (!('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  // Chiediamo permesso solo se non e' mai stato richiesto
  try {
    const r = await Notification.requestPermission();
    return r;
  } catch {
    return 'default';
  }
}

function showBrowserNotification(notif) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible') return; // gia visibile in UI
  // Rispetta le preferenze utente: pop-up disabilitato globalmente o per categoria
  if (typeof getUserPrefs === 'function') {
    const prefs = getUserPrefs();
    if (prefs && prefs.browser_push === false) return;
  }
  const cat = notif.category || notif.source_event?.split('.').slice(0, 2).join('.');
  if (cat && typeof isNotifMuted === 'function' && isNotifMuted(cat)) return;
  const tag = notif.id;
  const n = new Notification(notif.title, {
    body: notif.body || '',
    tag,
    icon: '/logo.png'
  });
  n.onclick = () => {
    window.focus();
    handleNotificationClick(notif);
    n.close();
  };
  setTimeout(() => {
    try {
      n.close();
    } catch {}
  }, 10000);
}

// ===== Render bell + dropdown =====
// G9: SVG sostituiscono le emoji per rendering consistente cross-OS
function priorityIcon(p) {
  if (p === 'critical')
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" style="color:var(--danger);width:14px;height:14px;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>`;
  if (p === 'warning')
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" style="color:var(--warning);width:14px;height:14px;"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`;
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" style="color:var(--primary);width:14px;height:14px;"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>`;
}

function relativeTime(iso) {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  const diff = Date.now() - t;
  if (diff < 60000) return 'adesso';
  if (diff < 3600000) return Math.floor(diff / 60000) + ' min fa';
  if (diff < 86400000) return Math.floor(diff / 3600000) + ' h fa';
  if (diff < 30 * 86400000) return Math.floor(diff / 86400000) + ' gg fa';
  return fmtDate(iso);
}

function renderBell() {
  const badge = document.getElementById('notifBadge');
  if (!badge) return;
  if (_notifUnread > 0) {
    badge.textContent = _notifUnread > 99 ? '99+' : String(_notifUnread);
    badge.classList.remove('hidden');
  } else {
    badge.classList.add('hidden');
  }
}

function renderNotifDropdown() {
  const dd = document.getElementById('notifDropdown');
  if (!dd) return;
  const items = _notifications.slice(0, 50);
  if (!items.length) {
    dd.querySelector('.notif-list').innerHTML = '<div class="notif-empty">Nessuna notifica.</div>';
    return;
  }
  dd.querySelector('.notif-list').innerHTML = items
    .map((n) => {
      const unread = !n.read_at;
      return `
      <div class="notif-item ${unread ? 'unread' : ''} prio-${n.priority || 'info'}" data-nid="${escapeHtml(n.id)}">
        <span class="notif-ico">${priorityIcon(n.priority)}</span>
        <div class="notif-text">
          <div class="notif-title">${escapeHtml(n.title)}</div>
          <div class="notif-body">${escapeHtml(n.body || '')}</div>
          <div class="notif-meta">${relativeTime(n.created_at)}</div>
        </div>
        <button class="notif-del" data-del title="Rimuovi">✕</button>
      </div>`;
    })
    .join('');

  dd.querySelectorAll('.notif-item').forEach((el) => {
    el.addEventListener('click', async (e) => {
      if (e.target.closest('[data-del]')) return;
      const id = el.dataset.nid;
      const notif = _notifications.find((x) => x.id === id);
      if (!notif) return;
      if (!notif.read_at) {
        await notifApi.markRead(id).catch(() => {});
        notif.read_at = new Date().toISOString();
        _notifUnread = Math.max(0, _notifUnread - 1);
        renderBell();
      }
      handleNotificationClick(notif);
      toggleNotifDropdown(false);
      renderNotifDropdown();
    });
    el.querySelector('[data-del]')?.addEventListener('click', async (e) => {
      e.stopPropagation();
      const id = el.dataset.nid;
      try {
        await notifApi.remove(id);
        _notifications = _notifications.filter((x) => x.id !== id);
        renderNotifDropdown();
      } catch (err) {
        console.error(err);
        toast('Errore eliminazione notifica');
      }
    });
  });
}

function handleNotificationClick(notif) {
  const p = notif.payload || {};
  // Heuristica: se ha "cliente", apri il modal cliente
  if (p.cliente && typeof openModal === 'function') {
    const tab =
      p.view === 'scadenze' ? 'scadenze' : p.view === 'contratto' ? 'contratto' : 'anagrafica';
    openModal(p.cliente, tab);
    return;
  }
  if (p.view && typeof setView === 'function') {
    setView(p.view);
  }
}

function toggleNotifDropdown(force) {
  const dd = document.getElementById('notifDropdown');
  if (!dd) return;
  const open = force === undefined ? !dd.classList.contains('open') : !!force;
  dd.classList.toggle('open', open);
  if (open) renderNotifDropdown();
}

async function refreshNotifications() {
  try {
    const [list, unread] = await Promise.all([notifApi.list(50), notifApi.unreadCount()]);
    _notifications = list;
    _notifUnread = unread;
    renderBell();
    renderNotifDropdown();
  } catch (e) {
    console.warn('Refresh notifiche fallito:', e.message || e);
  }
}

// ===== Realtime subscribe =====
function startNotificationRealtime() {
  stopNotificationRealtime();
  const profile = getCurrentUser?.();
  if (!profile?.id) return;
  _notifRealtimeChannel = sb
    .channel('notif:' + profile.id)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'notifications',
        filter: `user_id=eq.${profile.id}`
      },
      (payload) => {
        const n = payload.new;
        _notifications.unshift(n);
        if (!n.read_at) _notifUnread++;
        renderBell();
        renderNotifDropdown();
        // Popup browser se tab in background e permesso concesso
        showBrowserNotification(n);
        // Toast leggero anche in-app (G9: niente emoji)
        toast(n.title);
      }
    )
    .subscribe();

  // Polling di backup ogni 60s (resilienza se il channel realtime si disconnette)
  if (_notifPollTimer) clearInterval(_notifPollTimer);
  _notifPollTimer = setInterval(refreshNotifications, 60000);
}

function stopNotificationRealtime() {
  try {
    if (_notifRealtimeChannel) sb.removeChannel(_notifRealtimeChannel);
  } catch {}
  _notifRealtimeChannel = null;
  if (_notifPollTimer) {
    clearInterval(_notifPollTimer);
    _notifPollTimer = null;
  }
}

// ===== Bootstrap al login =====
async function bootstrapNotificationsForLogin() {
  await refreshNotifications();
  startNotificationRealtime();
  // Richiesta permesso silenziosa (solo se mai chiesto)
  if ('Notification' in window && Notification.permission === 'default') {
    setTimeout(() => ensureBrowserNotifPermission(), 1500);
  }
  // Riepilogo unread (richiesta esplicita dell'utente)
  if (_notifUnread > 0) {
    setTimeout(() => {
      toast(
        `Hai ${_notifUnread} notific${_notifUnread === 1 ? 'a' : 'he'} non lett${_notifUnread === 1 ? 'a' : 'e'}. Apri il pannello in alto a destra.`
      );
    }, 600);
  }
}

// ===== Wire-up =====
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('notifBellBtn')?.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleNotifDropdown();
  });
  document.getElementById('notifMarkAllRead')?.addEventListener('click', async () => {
    try {
      const n = await notifApi.markAllRead();
      _notifications = _notifications.map((x) => ({
        ...x,
        read_at: x.read_at || new Date().toISOString()
      }));
      _notifUnread = 0;
      renderBell();
      renderNotifDropdown();
      toast(`${n} notifiche segnate come lette`);
    } catch (e) {
      console.error(e);
      toast('Errore: ' + (e.message || e));
    }
  });
  document.getElementById('notifEnableBrowser')?.addEventListener('click', async () => {
    const r = await ensureBrowserNotifPermission();
    if (r === 'granted') toast('Notifiche browser attivate ✓');
    else if (r === 'denied')
      toast('Notifiche browser bloccate dal browser. Sbloccale dalle impostazioni del sito.');
    else if (r === 'unsupported') toast('Il tuo browser non supporta le notifiche');
    else toast('Notifiche browser non attivate');
  });

  // Click esterno chiude il dropdown
  document.addEventListener('click', (e) => {
    const dd = document.getElementById('notifDropdown');
    const btn = document.getElementById('notifBellBtn');
    if (!dd || !dd.classList.contains('open')) return;
    if (dd.contains(e.target) || btn?.contains(e.target)) return;
    toggleNotifDropdown(false);
  });
});

Object.assign(globalThis, {
  notifApi,
  ensureBrowserNotifPermission,
  refreshNotifications,
  startNotificationRealtime,
  stopNotificationRealtime,
  bootstrapNotificationsForLogin
});
export {};
